import { PROVIDERS } from "./constants";

export const mapProviderToDisplayName = (provider: string): string => {
  return PROVIDERS.find((p) => p.apiName === provider)?.displayName || provider;
};
